import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e17bab3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card w-75 p-5" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-4" }
const _hoisted_4 = { class: "col-4" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, null, -1))
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-4" }
const _hoisted_8 = { class: "col-4" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4" }, null, -1))
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-4" }
const _hoisted_12 = { class: "col-4" }
const _hoisted_13 = { class: "col-4" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "head" }, "social Media", -1))
const _hoisted_16 = {
  key: 0,
  class: "d-flex justify-content-between"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mb-7" }, null, -1))
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-6" }
const _hoisted_20 = { class: "d-flex justify-content-between" }
const _hoisted_21 = { class: "col-6" }
const _hoisted_22 = { class: "d-flex justify-content-between" }
const _hoisted_23 = { class: "card w-75 p-10 mt-5" }
const _hoisted_24 = { class: "head" }
const _hoisted_25 = { class: "d-flex gap-3 flex-wrap" }
const _hoisted_26 = {
  key: 2,
  class: "text-muted"
}
const _hoisted_27 = { class: "card w-75 p-10 mt-5" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "head" }, "Basic Info", -1))
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-6" }
const _hoisted_31 = { class: "col-6" }
const _hoisted_32 = { class: "row" }
const _hoisted_33 = { class: "col-6" }
const _hoisted_34 = { class: "col-6" }
const _hoisted_35 = { class: "row" }
const _hoisted_36 = { class: "col-6" }
const _hoisted_37 = { class: "col-6" }
const _hoisted_38 = { class: "row" }
const _hoisted_39 = { class: "col-3" }
const _hoisted_40 = { class: "col-3" }
const _hoisted_41 = { class: "col-6" }
const _hoisted_42 = { class: "row" }
const _hoisted_43 = { class: "col-8" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "head" }, "ID Info", -1))
const _hoisted_45 = { class: "row" }
const _hoisted_46 = { class: "col-6" }
const _hoisted_47 = { class: "col-6" }
const _hoisted_48 = { class: "row" }
const _hoisted_49 = { class: "col-6" }
const _hoisted_50 = { class: "col-6" }
const _hoisted_51 = { class: "row" }
const _hoisted_52 = { class: "col-4" }
const _hoisted_53 = { class: "card w-75 p-10 mt-5" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "head" }, "Options", -1))

import { onMounted, reactive, ref, inject } from "vue";
import type { FormInstance, FormRules } from "element-plus";
import TenantGlobalService from "@/projects/tenant/services/TenantGlobalService";
import UserService from "@/projects/tenant/modules/users/services/UserService";
import ChangeSiteModal from "./modal/ChangeSiteModal.vue";
import UpdateUserStatus from "./modal/UpdateUserStatus.vue";
import { useI18n } from "vue-i18n";
import { PartyStatusTypes } from "@/core/types/PartyStatusTypes";
import CopyButton from "@/components/CopyButton.vue";
import notification from "@/core/plugins/notification";
import { TagNames } from "@/core/types/TagTypes";
import TagsView from "@/projects/tenant/components/TagsView.vue";
import TimeShow from "@/components/TimeShow.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserPersonalInfos',
  setup(__props) {

const { t } = useI18n();
const changeSiteModalRef = ref<InstanceType<typeof ChangeSiteModal>>();
const updateUserStatusRef = ref<InstanceType<typeof UpdateUserStatus>>();
const showSiteId = ref("");
const ruleFormRef = ref<FormInstance>();
const formData = ref<Record<string, any>>({});
const isLoading = ref(false);
const isRemoving2FA = ref(false);
const userAuthTypes = ref<string[]>([]);

const userInfos = inject<any>("userInfos");
const checkedTags = ref<any>(userInfos.value.tags ?? []);

const tags = ref<any>([TagNames.Special]);
const partyId = inject<number>("partyId");
const rules = reactive<FormRules>({
  email: [
    { required: true, message: "Please input email", trigger: "blur" },
    { type: "email", message: "Please input correct email", trigger: "blur" },
  ],
  firstName: [
    { required: true, message: "Please input first name", trigger: "blur" },
  ],
  lastName: [
    { required: true, message: "Please input last name", trigger: "blur" },
  ],
});

const submitForm = async () => {
  if (!ruleFormRef.value) return;
  await ruleFormRef.value.validate(async (valid) => {
    if (valid) {
      try {
        isLoading.value = true;
        const res = await TenantGlobalService.updateUserProfileInfo(
          partyId.value,
          formData.value
        );
        notification.success();
        await resetForm(res);
        userInfos.value = res;
      } catch (error) {
        notification.danger();
      } finally {
        isLoading.value = false;
      }
    } else {
      notification.danger();
    }
  });
};

const updateTag = async (tag: any) => {
  isLoading.value = true;
  try {
    console.log("checkedTags", checkedTags.value);
    console.log("tag", tag);
    if (checkedTags.value.includes(tag)) {
      await UserService.updateUserTag(partyId.value, tag);
    } else {
      await UserService.deleteUserTag(partyId.value, tag);
    }
    notification.success();
  } catch (error) {
    notification.danger();
  } finally {
    isLoading.value = false;
  }
};

const updateStatus = async (newVal: any) => {
  try {
    isLoading.value = true;
    let form = {
      status: newVal,
    };
    await UserService.updateUserStatus(partyId.value, form);
    notification.success();
  } catch (error) {
    notification.danger();
  } finally {
    isLoading.value = false;
  }
};

const siteId = ref(userInfos.value.siteId ?? 0);

const updateSiteID = async (_siteId: number) => {
  showSiteId.value = t("type.siteType." + _siteId);
};

const resetForm = async (_initialFormData?: any) => {
  if (!ruleFormRef.value) return;
  ruleFormRef.value.resetFields();
  const initialForm = _initialFormData ?? userInfos.value;
  formData.value = {
    ...initialForm,
    gender: parseInt(initialForm.gender),
  };
};

const remove2FA = async (method: string) => {
  isRemoving2FA.value = true;
  try {
    await UserService.disable2FA(formData.value.email, method);
    notification.success();
    // Remove from local state after successful deletion
    userAuthTypes.value = userAuthTypes.value.filter((type) => type !== method);
  } catch (error) {
    notification.danger();
  } finally {
    isRemoving2FA.value = false;
  }
};

const fetchUserAuthTypes = () => {
  // Get userAuthTypes from the API response (userInfos)
  userAuthTypes.value = userInfos.value.userAuthTypes || [];
};

onMounted(() => {
  resetForm();
  fetchUserAuthTypes();

  showSiteId.value = t("type.siteType." + userInfos.value.siteId);
});

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_form, { "label-width": "100px" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_form_item, { label: "Party Id" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(userInfos).partyId), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_form_item, { label: "Party UID" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(userInfos).uid), 1)
                ]),
                _: 1
              })
            ]),
            _hoisted_5
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form, { "label-width": "100px" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_el_form_item, {
                label: _unref(t)('fields.createdOn')
              }, {
                default: _withCtx(() => [
                  _createVNode(TimeShow, {
                    dateIsoString: _unref(userInfos).createdOn,
                    type: "withoutSec"
                  }, null, 8, ["dateIsoString"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_el_form_item, {
                label: _unref(t)('fields.updatedOn')
              }, {
                default: _withCtx(() => [
                  _createVNode(TimeShow, {
                    dateIsoString: _unref(userInfos).updatedOn,
                    type: "withoutSec"
                  }, null, 8, ["dateIsoString"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _hoisted_9
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form, { "label-width": "100px" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_el_form_item, {
                label: _unref(t)('fields.lastLoginIp')
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(userInfos).lastLoginIp), 1)
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_el_form_item, {
                label: _unref(t)('fields.registeredIp')
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(userInfos).registeredIp), 1)
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_el_form_item, {
                label: _unref(t)('fields.language')
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(userInfos).language), 1)
                ]),
                _: 1
              }, 8, ["label"])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_el_form, { "label-width": "100px" }, {
        default: _withCtx(() => [
          (formData.value.socialMedium)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createVNode(_component_el_divider),
                _hoisted_15,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.value.socialMedium, (type, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                    (type.account != '')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _createVNode(_component_el_form_item, {
                            label: _ctx.$t('fields.' + type.name),
                            prop: type.name,
                            style: {"width":"90%"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: type.account,
                                "onUpdate:modelValue": ($event: any) => ((type.account) = $event),
                                disabled: ""
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1032, ["label", "prop"]),
                          _createVNode(CopyButton, {
                            class: "ms-3",
                            content: type.account
                          }, null, 8, ["content"])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128)),
                _hoisted_17
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_el_form_item, {
                  label: _unref(t)('fields.siteId'),
                  prop: "siteID",
                  style: {"width":"90%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: showSiteId.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showSiteId).value = $event)),
                      disabled: ""
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_button, {
                  class: "ms-3",
                  type: "primary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (changeSiteModalRef.value?.show(_unref(partyId), siteId.value)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("action.update")), 1)
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_el_form_item, {
                  label: _unref(t)('fields.status')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_switch, {
                      modelValue: _unref(userInfos).status,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(userInfos).status) = $event)),
                      "active-color": "#13ce66",
                      "inactive-color": "#ff4949",
                      "active-text": _unref(t)('status.active'),
                      "inactive-text": _unref(t)('status.inactive'),
                      "active-value": _unref(PartyStatusTypes).Active,
                      "inactive-value": _unref(PartyStatusTypes).Closed,
                      disabled: ""
                    }, null, 8, ["modelValue", "active-text", "inactive-text", "active-value", "inactive-value"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_button, {
                  class: "ms-3",
                  type: "primary",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (updateUserStatusRef.value?.show()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("action.update")), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t("fields.twoFactorAuthentication")), 1),
      _createVNode(_component_el_form, { "label-width": "100px" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('title.twoFaMethods')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_25, [
                (userAuthTypes.value.includes('email'))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      type: "danger",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (remove2FA('email'))),
                      loading: isRemoving2FA.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("fields.disable")) + " " + _toDisplayString(_ctx.$t("fields.email")), 1)
                      ]),
                      _: 1
                    }, 8, ["loading"]))
                  : _createCommentVNode("", true),
                (userAuthTypes.value.includes('authenticator'))
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      type: "danger",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (remove2FA('authenticator'))),
                      loading: isRemoving2FA.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("fields.disable")) + " " + _toDisplayString(_ctx.$t("tip.authenticator")), 1)
                      ]),
                      _: 1
                    }, 8, ["loading"]))
                  : _createCommentVNode("", true),
                (userAuthTypes.value.length === 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.$t("fields.no2faEnabled")), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_27, [
      _hoisted_28,
      _createVNode(_component_el_form, {
        ref_key: "ruleFormRef",
        ref: ruleFormRef,
        model: formData.value,
        rules: rules,
        "label-width": "100px"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createVNode(_component_el_form_item, {
                label: _unref(t)('fields.email'),
                prop: "email"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: formData.value.email,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.email) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_el_form_item, {
                label: _unref(t)('fields.gender'),
                prop: "gender"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio_group, {
                    modelValue: formData.value.gender,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.gender) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_radio, { label: 0 }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)("fields.male")), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_radio, { label: 1 }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(t)("fields.female")), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, [
              _createVNode(_component_el_form_item, {
                label: _unref(t)('fields.firstName'),
                prop: "firstName"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: formData.value.firstName,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.firstName) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createVNode(_component_el_form_item, {
                label: _unref(t)('fields.lastName'),
                prop: "lastName"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: formData.value.lastName,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.value.lastName) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _createVNode(_component_el_form_item, {
                label: _unref(t)('fields.nativeName'),
                prop: "nativeName"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: formData.value.nativeName,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.nativeName) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createVNode(_component_el_form_item, {
                label: _unref(t)('fields.birthdate'),
                prop: "birthday"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: formData.value.birthday,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.value.birthday) = $event)),
                    type: "date",
                    "value-format": "YYYY-MM-DD"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ])
          ]),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _createVNode(_component_el_form_item, {
                "label-width": 100,
                label: _unref(t)('fields.citizen'),
                prop: "citizen"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: formData.value.citizen,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.value.citizen) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createVNode(_component_el_form_item, {
                "label-width": 100,
                label: "ccc",
                prop: "ccc"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: formData.value.ccc,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formData.value.ccc) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_41, [
              _createVNode(_component_el_form_item, {
                "label-width": 100,
                label: _unref(t)('fields.phone'),
                prop: "phoneNumber"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: formData.value.phoneNumber,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formData.value.phoneNumber) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ])
          ]),
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _createVNode(_component_el_form_item, {
                label: _unref(t)('fields.address'),
                prop: "address"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: formData.value.address,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((formData.value.address) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ])
          ]),
          _createVNode(_component_el_divider),
          _hoisted_44,
          _createVNode(_component_el_form_item, {
            label: _unref(t)('fields.idType'),
            prop: "idType"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_radio_group, {
                modelValue: formData.value.idType,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formData.value.idType) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio, { label: 1 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("fields.govId")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, { label: 2 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("fields.driveLicense")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, { label: 3 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("fields.passport")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _createVNode(_component_el_form_item, {
                label: _unref(t)('fields.idNumber'),
                prop: "idNumber"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: formData.value.idNumber,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((formData.value.idNumber) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createVNode(_component_el_form_item, {
                label: _unref(t)('fields.idIssuer'),
                prop: "idIssuer"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: formData.value.idIssuer,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((formData.value.idIssuer) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ])
          ]),
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("div", _hoisted_49, [
              _createVNode(_component_el_form_item, {
                label: _unref(t)('fields.idIssuedOn'),
                prop: "idIssuedOn"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: formData.value.idIssuedOn,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((formData.value.idIssuedOn) = $event)),
                    type: "date",
                    "value-format": "YYYY-MM-DD"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _createElementVNode("div", _hoisted_50, [
              _createVNode(_component_el_form_item, {
                label: _unref(t)('fields.idExpiresOn'),
                prop: "idExpireOn"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    modelValue: formData.value.idExpireOn,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((formData.value.idExpireOn) = $event)),
                    type: "date",
                    "value-format": "YYYY-MM-DD"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ])
          ]),
          _createVNode(_component_el_divider),
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("div", _hoisted_52, [
              _createVNode(_component_el_form_item, {
                "label-width": 100,
                label: "Refer Code",
                prop: "Refer Code"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: formData.value.referCode,
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((formData.value.referCode) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: submitForm,
                loading: isLoading.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("action.submit")), 1)
                ]),
                _: 1
              }, 8, ["loading"]),
              _createVNode(_component_el_button, {
                disabled: isLoading.value,
                onClick: _cache[22] || (_cache[22] = ($event: any) => (resetForm()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("action.reset")), 1)
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"]),
      _createVNode(ChangeSiteModal, {
        ref_key: "changeSiteModalRef",
        ref: changeSiteModalRef,
        onUpdateSiteID: updateSiteID
      }, null, 512),
      _createVNode(UpdateUserStatus, {
        ref_key: "updateUserStatusRef",
        ref: updateUserStatusRef
      }, null, 512)
    ]),
    _createElementVNode("div", _hoisted_53, [
      _hoisted_54,
      _createVNode(TagsView, {
        type: "party",
        id: _unref(partyId)
      }, null, 8, ["id"])
    ])
  ], 64))
}
}

})